'use client';

import { FaqRescheduleCancelAppointmentCard } from './cards/faq-reschedule-cancel-appointment-card.component';
import { FaqWantToScheduleCard } from './cards/faq-want-to-schedule-card.component';
import Faq from './faq.component';

import { FaqTopic } from '@/app/(main)/(pages)/(institucional)/preciso-de-ajuda/_types/faq.type';

interface FaqPatientTabContentProps {
  faqContent: FaqTopic[];
  isActiveStageOne: boolean;
}

export const FaqPatientTabContent = ({ faqContent, isActiveStageOne }: FaqPatientTabContentProps) => {
  return (
    <>
      <FaqWantToScheduleCard />
      <FaqRescheduleCancelAppointmentCard isActiveStageOne={isActiveStageOne} />
      <Faq content={faqContent} />
    </>
  );
};
